import axios, { AxiosRequestConfig } from './axios';

export type JsonPatchOperation = 'add' | 'remove' | 'replace' | 'move' | 'copy' | 'test';

const jsonPatchFunction = (
  url: string,
  operations: JsonPatchRequest[],
  config?: AxiosRequestConfig
) =>
  axios.patch(url, operations, {
    headers: jsonPatchHeaders,
    ...config
  });

// Add jsonPatch to axiosInstance
axios.jsonPatch = jsonPatchFunction as JsonPatchFunction;

export interface JsonPatchRequest {
  op: JsonPatchOperation;
  path: string;
  value?: any;
  from?: string;
}

export type JsonPatchFunction = (
  url: string,
  operations: JsonPatchRequest[],
  config?: AxiosRequestConfig
) => Promise<any>;

export const jsonPatchHeaders: AxiosRequestConfig['headers'] = {
  'Content-Type': 'application/json-patch+json'
};

const createPatchOperation = (
  op: JsonPatchOperation,
  path: string,
  value?: any,
  from?: string
): JsonPatchRequest => {
  const operation: JsonPatchRequest = { op, path };

  if (value !== undefined) {
    operation.value = value;
  }

  if (from) {
    operation.from = from;
  }

  return operation;
};

export const replace = (path: string, value: any) => createPatchOperation('replace', path, value);
